import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

export default function NotFound() {
    return (
        <Box
            component='section'
            sx={{
                minHeight: '70vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 2,
                pt: { xs: 12, md: 14 },
                pb: 6,
                textAlign: 'center',
            }}
        >
            <Helmet>
                <title>Nie znaleziono strony | Nekrodruk.pl</title>
                <meta name='robots' content='noindex' />
            </Helmet>
            <Stack spacing={2} alignItems='center' sx={{ maxWidth: 520 }}>
                <Typography component='p' sx={{ fontSize: '4rem', fontWeight: 700, color: '#5189B0', lineHeight: 1 }}>
                    404
                </Typography>
                <Typography component='h1' variant='h4' sx={{ fontWeight: 600 }}>
                    Nie znaleziono strony
                </Typography>
                <Typography color='text.secondary'>
                    Strona, której szukasz, nie istnieje albo została przeniesiona.
                </Typography>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ pt: 1 }}>
                    <Button component={RouterLink} to='/' variant='contained' sx={{ textTransform: 'none', fontWeight: 600 }}>
                        Wróć na stronę główną
                    </Button>
                    <Button component={RouterLink} to='/demo' variant='outlined' sx={{ textTransform: 'none', fontWeight: 600 }}>
                        Wypróbuj demo
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
}
